<template>
  <layout-main-inner title="产品管理">
    <layout-card-wrap :hasSlot="true">
      <template slot="form">
        <!-- <ent-auto-select
          v-model="config.vendorId"
          style="margin-right: 10px"
          :callback="()=> { handleCurrentChange(1) }" /> -->
        <el-input
          v-model="config.productName"
          clearable
          style="width: 240px"
          placeholder="请输入产品名称"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"
          ></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="商品名称"
          min-width="200"
          prop="productName"> </el-table-column>
        <el-table-column
          label="企业名称"
          min-width="130"
          prop="vendorName">
        </el-table-column>
        <el-table-column
          label="商品类型"
          min-width="130"
          prop="categoryName">
        </el-table-column>
        <el-table-column
          label="贸易类别"
          min-width="130"
          prop="tradeType">
          <template slot-scope="{ row }">
            {{ row.tradeType | tradeType() }}
          </template>
        </el-table-column>
        <el-table-column
          key="8"
          label="备案时间"
          width="140"
          prop="createdTime">
          <template slot-scope="{ row }">
            {{ row.createdTime | dateformat() }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="totalNum"
        @current-change="handleCurrentChange">
      </el-pagination>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
// import EntAutoSelect from '../../components/ent-auto-select.vue'
export default {
  name: 'ScmProducts',
  components: { },
  data() {
    return {
      loading: true,
      list: [],
      totalNum: 0,
      config: {
        pageNum: 1,
        pageSize: 10,
        productName: '',
        vendorId: null
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo,
      permission: (state) => state.account.permission
    })
  },
  mounted() {
    this.getlist()
  },
  methods: {
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$store.dispatch('zs/getproducts', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.totalNum = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
